import { render } from "./FastApi.vue?vue&type=template&id=85a0991a"
import script from "./FastApi.vue?vue&type=script&lang=js"
export * from "./FastApi.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__